import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const createProjectRoute: InvariantJiraRoute = {
	name: 'create-project',
	path: '/jira/create-project',
	exact: true,
};
